import clsx from 'clsx'
import {useState} from 'react'
import {Outlet} from 'react-router-dom'
import {ThemeContext} from 'partials/partials'
// import {Content} from './components/Content'
import {Footer} from './components/Footer'
import HeaderWrapper from './components/header/HeaderWrapper'
import {PageDataProvider} from './master-layout'

const MasterLayout = () => {
 const [theme, setTheme] = useState('light')
 /* const [collapse, setCollapse] = useState<boolean | null>(
  true
 ) */
 // const [width, setWidth] = useState<any | null>(
 //   'md:w-[83.4%] md:ml-[16.6vw] bg-gray-100 sm:w-full duration-1000 ease-in-out'
 // )
 const [width] = useState<string | null>(
  'md:w-[100%]  bg-gray-100 sm:w-full duration-1000 ease-in-out'
 )
 // functions
 /* const AdjustWidth = () => {
  if (!collapse) {
   setWidth(
    'md:w-[93%] md:ml-[7vw] bg-gray-100 duration-1000 ease-in-out'
   )
   setCollapse(true)
  } else {
   setCollapse(false)
   setWidth(
    ' md:ml-[16.6vw] md:w-[83.4%] bg-gray-100 sm:w-full duration-1000 ease-in-out'
   )
  }
 } */

 return (
  <PageDataProvider>
   <ThemeContext.Provider value={{theme, setTheme}}>
    <>
     <div data-testid='master' className={`theme-${theme}`}>
      <div className={clsx('main-page')}>
       {/* begin::Page */}
       <div className='page flex flex-row flex-col min-h-[100dvh]'>
        {/* <AsideMenuMain AdjustWidth={AdjustWidth} /> */}
        {/* begin::Wrapper */}
        <div
         className={`master_layout_main ${width} sm:relative md:sticky md:top-0 md:z-[50] sm:z-10 `}
        >
         <HeaderWrapper />
        </div>
        <div className={`flex-1 flex ${width}`}>
         <Outlet />
        </div>
        {/* end::Content */}

        <div className={`master_layout_main ${width}`}>
         {<Footer />}
        </div>

        {/* end::Wrapper */}
       </div>
       {/* end::Page */}
      </div>
     </div>
    </>
   </ThemeContext.Provider>
  </PageDataProvider>
 )
}

export {MasterLayout}
